export type CommsChannel = "support" | "legal" | "voicemail" | "primary"
export const COMMS_CHANNELS: readonly CommsChannel[] = ["support", "legal", "voicemail", "primary"]

/** Validate a `?channel=` value; anything unknown means "no channel lens" (all threads). */
export function parseCommsChannel(value: string | null): CommsChannel | null {
  return COMMS_CHANNELS.find((c) => c === value) ?? null
}
